// next
// import NextLink from "next/link";
// import Image from "next/legacy/image";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Button, Container, Grid, Link, Typography } from "@mui/material";

// third party
import { motion } from "framer-motion";

// project import
import AnimateButton from "../../components/@extended/AnimateButton";

// assets
import { EyeOutlined } from "@ant-design/icons";

import headertechimg from "../../assets/images/landing/img-headertech.svg";
import { navigateToUrl } from "single-spa";

// ==============================|| LANDING - HEADER PAGE ||============================== //

const HeaderPage = () => {
  const theme = useTheme();

  return (
    <Container
      sx={{ minHeight: "100vh", display: "flex", alignItems: "center" }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{ pt: { md: 0, xs: 8 }, pb: { md: 0, xs: 5 } }}
      >
        <Grid item xs={12} lg={5} md={6}>
          <Grid
            container
            spacing={2}
            sx={{
              pr: 10,
              [theme.breakpoints.down("md")]: { pr: 0, textAlign: "center" },
            }}
          >
            <Grid item xs={12}>
              <div>
                <Typography
                  variant="h1"
                  color="white"
                  sx={{
                    fontSize: { xs: "2.5rem", sm: "3rem", md: "5rem" },
                    fontWeight: 700,
                    lineHeight: { xs: 1.3, sm: 1.3, md: 1.3 },
                  }}
                >
                  <span>Autenticação e Assinatura com </span>
                  <Box
                    component="span"
                    sx={{ color: theme.palette.primary.main }}
                  >
                    <span>Segurança Inigualável</span>
                  </Box>
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div>
                <Typography
                  variant="h6"
                  component="div"
                  color="white"
                  sx={{
                    fontSize: { xs: "2rem", md: "2.5rem" },
                    fontWeight: 400,
                    lineHeight: { xs: 1.4, md: 1.4 },
                  }}
                >
                  Vá além da assinatura: valide, autentique e proteja com o
                  Bemsign
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sx={{ my: 3.25 }}>
              <div>
                <Grid
                  container
                  spacing={2}
                  sx={{ justifyContent: { xs: "center", md: "flex-start" } }}
                >
                  {/* <Grid item>
                    <AnimateButton>
                      <Button
                        size="large"
                        color="primary"
                        variant="outlined"
                        component={Link}
                        target="_blank"
                      >
                        Explore Components
                      </Button>
                    </AnimateButton>
                  </Grid> */}
                  <Grid item>
                    <AnimateButton>
                      <Button
                        component={Link}
                        target="_blank"
                        size="large"
                        color="primary"
                        variant="contained"
                        onClick={() => navigateToUrl("/login")}
                        // startIcon={
                        //   <EyeOutlined style={{ fontSize: "1.15rem" }} />
                        // }
                        style={{ fontSize: "1.2rem" }}
                      >
                        Entre em Contato
                      </Button>
                    </AnimateButton>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            {/* <Grid item xs={12}>
              <div>
                <img
                  src={headertechimg}
                  alt="Mantis"
                  width={223}
                  height={49}
                  style={{ zIndex: 9 }}
                />
              </div>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          lg={7}
          md={6}
          sx={{ display: { xs: "none", md: "flex" } }}
        />
      </Grid>
    </Container>
  );
};

export default HeaderPage;
